"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _DotCarousel = _interopRequireDefault(require("../DotCarousel"));
var _mobileCarouselStyles = require("./mobileCarouselStyles");
var MobileCarouselSkeleton = function MobileCarouselSkeleton(_ref) {
  var preloadedMainImage = _ref.preloadedMainImage;
  return /*#__PURE__*/_react["default"].createElement(_DotCarousel["default"], {
    onChangeSlide: _noop["default"],
    infiniteLoop: true,
    scrollMode: "peek",
    useSkeleton: true
  }, /*#__PURE__*/_react["default"].createElement(_mobileCarouselStyles.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_mobileCarouselStyles.SlideContent, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: preloadedMainImage,
    alt: "",
    role: "presentation",
    onClick: _noop["default"]
  }))), /*#__PURE__*/_react["default"].createElement(_mobileCarouselStyles.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_mobileCarouselStyles.SlideContent, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: preloadedMainImage,
    alt: "",
    role: "presentation",
    onClick: _noop["default"]
  }))));
};
MobileCarouselSkeleton.propTypes = {
  preloadedMainImage: _propTypes["default"].string.isRequired
};
var _default = MobileCarouselSkeleton;
exports["default"] = _default;
//# sourceMappingURL=_MobileCarouselSkeleton.js.map